<svg [attr.width]="width" [attr.height]="height" [attr.viewBox]="viewBox" class="cds-cursor-pointer">
  @for(line of grid; track $index) {
    <path [attr.d]="line.d" [attr.stroke]="line.color" fill="none"></path>
  }

  <g [attr.transform]="yAxisLabelTransform">
    <text
      x="0" y="0"
      text-anchor="middle"
      dominant-baseline="middle"
      font-size="13"
      font-weight="700"
      [attr.style]="'font-family: Lato, sans-serif'"
      text-rendering="geometricPrecision">{{yAxisLabel}}</text>
  </g>

  <text
    [attr.y]="height - 2"
    [attr.x]="round(paddingLeft + innerWidth / 2)"
    text-anchor="middle"
    font-size="13"
    font-weight="700"
    [attr.style]="'font-family: Lato, sans-serif'"
    text-rendering="geometricPrecision">{{xAxisLabel}}</text>

  @for(l of xAxisLabels; track $index) {
    <text
      [attr.x]="round(l.x)"
      [attr.y]="height - paddingBottom + 16"
      text-anchor="middle"
      font-size="13"
      [attr.style]="'font-family: Lato, sans-serif'"
      text-rendering="geometricPrecision">{{l.label}}</text>
  }

  @for(bar of value; track $index) {
    <text
      [attr.x]="paddingLeft - 6"
      [attr.y]="round(paddingTop + barSlotHeight * $index + barSlotHeight / 2 + 4)"
      text-anchor="end"
      font-size="13"
      font-weight="700"
      [attr.style]="'font-family: Lato, sans-serif'"
      text-rendering="geometricPrecision">{{bar.label}}</text>
  }

  @for(bar of value; track $index) {
    <path
      [attr.d]="getHorizontalBarPath(bar, $index)"
      [attr.fill]="bar.color"
      (click)="getFilterData(bar.label)">
    </path>
    <text
      [attr.x]="round(paddingLeft + (bar.value / maxValue) * innerWidth + 6)"
      [attr.y]="round(paddingTop + barSlotHeight * $index + barSlotHeight / 2 + 4)"
      text-anchor="start"
      font-size="13"
      font-weight="700"
      [attr.style]="'font-family: Lato, sans-serif'"
      text-rendering="geometricPrecision"
      (click)="getFilterData(bar.label)">{{bar.value}}</text>
  }
</svg>
